if (!customElements.get('pdp-gallery-dots')) {
	customElements.define(
		'pdp-gallery-dots',
		class PdpGalleryDots extends HTMLElement {
			connectedCallback() {
				this.targetId = this.dataset.target;
				this.poll = setInterval(() => this.tryInit(), 150);
				this.giveUp = setTimeout(() => clearInterval(this.poll), 10000);
			}

			disconnectedCallback() {
				clearInterval(this.poll);
				clearTimeout(this.giveUp);
				if (this.instance) this.instance.off('select', this.onSelect);
			}

			tryInit() {
				const gallery = document.getElementById(this.targetId);
				const instance = gallery && gallery.slider && gallery.slider.instance;
				if (!instance || !instance.cells) return;

				clearInterval(this.poll);
				clearTimeout(this.giveUp);
				this.instance = instance;

				const count = instance.cells.length;
				if (count < 2) return;

				const list = document.createElement('div');
				list.className = 'pdp-gallery-dots__list';
				list.setAttribute('role', 'tablist');
				list.setAttribute('aria-label', 'Navigation galerie');

				this.dots = [];
				for (let i = 0; i < count; i++) {
					const dot = document.createElement('button');
					dot.type = 'button';
					dot.className = 'pdp-gallery-dots__dot';
					dot.setAttribute('aria-label', 'Aller au visuel ' + (i + 1));
					dot.addEventListener('click', () => this.instance.select(i));
					list.appendChild(dot);
					this.dots.push(dot);
				}
				const viewer = gallery.closest('[data-media-viewer]') || this;
				viewer.appendChild(list);

				this.onSelect = () => this.update();
				this.instance.on('select', this.onSelect);
				this.update();
			}

			update() {
				const selected = this.instance.selectedIndex;
				this.dots.forEach((dot, i) => {
					dot.classList.toggle('is-active', i === selected);
					dot.setAttribute('aria-current', i === selected ? 'true' : 'false');
				});
			}
		}
	);
}
